import React, { ReactNode, useCallback } from 'react';
import clsx from 'clsx';

import Box from '../../../../styled/Box';
import Panel from '../../../../styled/Panel';
import useHistory from '../../../../Router/useHistory';
import useToggle from '../../../../hooks/useToggle';
import { Body } from '../../../../styled/ScrollBox/wrappers';
import { CheckIcon } from '../../../../styled/Icon';
import { HighlightBox } from '../../../../styled/HighlightBox/wrappers';
import { formatImage } from '../../../../utils/image';

import {
  ValueButton,
  MediaContainer,
  Image,
  TextContainer,
  Action,
  Value,
  Label,
} from '../../../../styled/ValueButton/wrappers';
import ImageBox from '../../../../styled/ImageBox';
import Distance from '../../../../styled/Distance';
import useContext from '../../../../hooks/useContext';
import { ProductContext } from '../providers/ProductProvider';
interface IOptionWrapper {
  active: boolean;
  children: ReactNode;
  id: string;
  onSelect: () => void;
}

const OptionWrapper = ({ active, children, id, onSelect }: IOptionWrapper) => {
  const { push } = useHistory();

  const click = useCallback(() => {
    push({ search: `?id=${id}` });
    onSelect();
  }, [id, onSelect]);

  return (
    <ValueButton className={clsx(active && 'active', 'padding-none')}>
      {children}
      <Action onClick={click}>
        {active && (
          <>
            Vald <CheckIcon className="m-l-half" />
          </>
        )}
        {!active && 'Välj'}
      </Action>
    </ValueButton>
  );
};

const Option = ({ name, value, options }: IAdjacentOptions) => {
  const [showPanel, toggleShowPanel] = useToggle(false);

  return (
    <>
      <HighlightBox>
        <ValueButton onClick={toggleShowPanel}>
          <TextContainer>
            <Label>{name}</Label>
            <Value>{value}</Value>
          </TextContainer>
          <Action>Ändra</Action>
        </ValueButton>
      </HighlightBox>

      {showPanel && (
        <Panel
          title={`Välj ${name.toLocaleLowerCase()}`}
          className="no-body-padding"
          onClose={toggleShowPanel}>
          <Box padding="3">
            <Body>
              {options.map((o) => (
                <OptionWrapper key={o.id} id={o.id} onSelect={toggleShowPanel} active={o.selected}>
                  {(name === 'Utförande' || name === 'Variant') && (
                    <MediaContainer>
                      <ImageBox width="56px" height="56px">
                        <picture>
                          <source
                            type="image/webp"
                            srcSet={formatImage(o.image, {
                              width: 56,
                              height: 56,
                              cdn: true,
                              output: 'webp',
                            })}
                          />
                          <Image
                            src={formatImage(o.image, {
                              width: 56,
                              height: 56,
                              cdn: true,
                              output: 'jpg',
                            })}
                          />
                        </picture>
                      </ImageBox>
                    </MediaContainer>
                  )}
                  <TextContainer>
                    <Value>{o.value}</Value>
                  </TextContainer>
                </OptionWrapper>
              ))}
            </Body>
          </Box>
        </Panel>
      )}
    </>
  );
};

interface IvariantSelection {
  distance?: string;
}

const VariantSelection = ({ distance }: IvariantSelection) => {
  const { adjacentOptions } = useContext(ProductContext);

  if (!adjacentOptions?.length) {
    return null;
  }

  return (
    <>
      {adjacentOptions.map((o) => (
        <Option key={o.value} {...o} />
      ))}

      {distance && <Distance size={distance} />}
    </>
  );
};

export default VariantSelection;
